module.exports = __webpack_public_path__ + "img/du.713c517a.png";